import { Component, Input, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { ITreatmentCategory } from '@app/salon-details/models/treatment-category.model';
import { smoothScrollToElementId } from '@app/shared/utils';
import { CommonModule } from '@angular/common';
import { FeatherModule } from 'angular-feather';
import { fromEvent, Subscription, bufferTime, filter, tap } from 'rxjs';

@Component({
  selector: 'app-scroll-to-category',
  templateUrl: './scroll-to-category.component.html',
  styleUrls: ['./scroll-to-category.component.scss'],
  standalone: true,
  imports: [CommonModule, FeatherModule]
})

export class ScrollToCategoryComponent implements AfterViewInit, OnDestroy {
  @Input() treatmentCategories: ITreatmentCategory[];
  @ViewChild('scrollContainer', { static: true }) scrollContainerRef: ElementRef;
  isSticky = false;
  private readonly bufferScrollEventTimeConst = 250;
  private readonly masterSubscription = new Subscription();

  ngAfterViewInit(): void {
    this.masterSubscription
      .add(fromEvent(window, 'scroll')
        .pipe(
          /**
           * @description
           * used to not compute element position too often,
           * we are interested in the latest value after scroll not each emitted value
           *
           * scrollend event is not used on purpose as it reacts "to slow"
           * so the UX feel kind of lagy when used
           */
          bufferTime(this.bufferScrollEventTimeConst),
          filter((data) => data.length > 0),
          tap(() => {
            this.isSticky = !this.isElementInViewport(this.scrollContainerRef.nativeElement)
              && window.scrollY >= this.scrollContainerRef.nativeElement.getBoundingClientRect().top;
          }))
        .subscribe()
      );
  }

  ngOnDestroy(): void {
    this.masterSubscription.unsubscribe();
  }

  public scrollToCategory(treatmentCategoryId: string): void {
    const categoryHeaderHeightCompensation = 100;
    smoothScrollToElementId(treatmentCategoryId, 500, categoryHeaderHeightCompensation);
  }

  private isElementInViewport(el: HTMLElement): boolean {
    var rect = el.getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
}
